import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import Login from "./Login";
import Register from "./Register";
import HeaderAuth from "../../components/HeaderAuth";

export default function AuthPage() {
	return (
		<div className="login flex-column">
			<HeaderAuth />
			<Switch>
				<Route path="/auth/login" component={Login} />
				<Route path="/auth/register" component={Register} />
				<Redirect from="/auth" exact={true} to="/auth/login" />
				<Redirect to="/auth/login" />
			</Switch>
		</div>
	);
}
